// extracted by mini-css-extract-plugin
export default {"desktop":"DeskTop_desktop__NQP2m","innerdesktop":"DeskTop_innerdesktop__L6jVS"};